import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import JobPaymentRequests from '../job/tasks/JobPaymentRequests'

const propTypes = {}

class PaymentRequestsContainer extends Component {
  render() {
    return (
      <JobPaymentRequests
        {...this.props}
        fromDashboard={true}
        user={this.props.authentication.user}
      />
    )
  }
}

const mapStateToProps = ({ authentication }, ownProps) => ({ authentication })
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}), dispatch)
})

PaymentRequestsContainer.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentRequestsContainer))



// WEBPACK FOOTER //
// ./src/containers/dashboard/PaymentRequestsContainer.js